"use strict";import{IconCopy as o}from"../src/elements/IconCopy.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-icon-copy",o);
//# sourceMappingURL=sp-icon-copy.js.map
